import React, { useEffect, useState } from "react";
import { Button, Card, Form } from "react-bootstrap";
import Select from "../../../common/components/Select/Select";

import FloatingLabelInput from "../../../common/components/FloatingLabelInput";
import FormSelect from "../../../common/components/FormSelect";
import SideBar, { Body } from "../../../common/components/SearchFilters/SideBar";

const FilterSideBar = ({
  filterOptions: {
    location_options: locationOptions,
    grade_options: gradeOptions,
    status_options: statusOptions,
    immunization_record_status_options: immunizationRecordStatusOptions,
    immunization_options: immunizationOptions,
    archived_options: archivedOptions,
    sort_options: sortOptions,
    tag_options: tagOptions,
  },
  filters,
  onClose,
  setFilters,
  showSideBar,
}) => {

  // temporary filter state when opening the sidebar
  // sidebarFilter and filters get syncronized when user clicks "Apply filters"
  const [sideBarFilters, setSideBarFilters] = useState(filters);

  useEffect(() => {
    setSideBarFilters(filters);
  }, [filters]);

  const handleApplyFilters = () => {
    setFilters(sideBarFilters);
    onClose();
  };

  const setSideBarFieldValue = (field, value) => {
    setSideBarFilters({ ...sideBarFilters, [field]: value });
  };

  return (
    <SideBar
      id="studentProfilesFiltersSideBar"
      onClose={onClose}
      placement="end"
      show={showSideBar}
      title={`Filters`}
    >
      <Body>
        <div className="d-flex flex-column justify-content-between">
          <div className="my-3">
            <FloatingLabelInput
              label="Search by name or student ID"
              value={sideBarFilters.q_student}
              onChange={(e) => setSideBarFieldValue("q_student", e.target.value)}
              className="my-3"
              prependIcon="search"
            />
            <div className="my-3">
              <Form.Group>
                <Form.Label>Location</Form.Label>
                <FormSelect
                  options={locationOptions}
                  onChange={(id) => setSideBarFieldValue("appointment_slot_group_id", id)}
                  selected={locationOptions.filter(o => o.value === sideBarFilters.appointment_slot_group_id)}
                />
              </Form.Group>
            </div>
            <div className="my-3">
              <Form.Group>
                <Form.Label>Grade</Form.Label>
                <FormSelect
                  options={gradeOptions}
                  onChange={(id) => setSideBarFieldValue("grade", id)}
                  selected={gradeOptions.filter(o => o.value === sideBarFilters.grade)}
                />
              </Form.Group>
            </div>
            <div className="my-3">
              <Form.Group>
                <Form.Label>Immunization status</Form.Label>
                <Select
                  isMulti
                  options={statusOptions || []}
                  value={sideBarFilters.student_immunization_status || []}
                  onChange={(values) => setSideBarFieldValue("student_immunization_status", values)}
                  valueKey="value"
                  labelKey="label"
                  placeholder=""
                />
              </Form.Group>
            </div>
            <Card className="my-3 p-3">
              <Form.Group>
                <Form.Label>Immunization Compliance Status</Form.Label>
                <Select
                  isMulti
                  options={immunizationRecordStatusOptions || []}
                  value={sideBarFilters.immunization_record_status || []}
                  onChange={(values) => setSideBarFieldValue("immunization_record_status", values.join(","))}
                  valueKey="value"
                  labelKey="label"
                  placeholder=""
                />
              </Form.Group>
              <Form.Group>
                <Form.Label>Immunization</Form.Label>
                <Select
                  isMulti
                  options={immunizationOptions || []}
                  value={sideBarFilters.immunization || []}
                  onChange={(values) => setSideBarFieldValue("immunization", values.join(","))}
                  valueKey="value"
                  labelKey="label"
                  placeholder=""
                />
              </Form.Group>
            </Card>
            <div className="my-3">
              <Form.Group>
                <Form.Label>Tags</Form.Label>
                <Select
                  isMulti
                  options={tagOptions || []}
                  value={sideBarFilters.tags || []}
                  onChange={(values) => {
                    const tagsString = values.join(',');
                    setSideBarFieldValue("tags", tagsString);
                  }}
                  valueKey="value"
                  labelKey="label"
                  placeholder=""
                />
              </Form.Group>
            </div>
            <div className="my-3">
              <Form.Group>
                <Form.Label>Active status</Form.Label>
                <FormSelect
                  options={archivedOptions || []}
                  onChange={(value) => setSideBarFieldValue("archived", value)}
                  selected={sideBarFilters.archived || "false"}
                />
              </Form.Group>
            </div>
            <div className="my-3">
              <Form.Group>
                <Form.Label>Sort name</Form.Label>
                <FormSelect
                  options={sortOptions || []}
                  onChange={(value) => setSideBarFieldValue("sort_by", value)}
                  selected={sideBarFilters.sort_by || "last_name_asc"}
                />
              </Form.Group>
            </div>
          </div>
          <div>
            <Button
              block
              className="my-3 w-100"
              onClick={handleApplyFilters}
            >
              Apply filters
            </Button>
          </div>
        </div>
      </Body>
    </SideBar>
  );
};

export default FilterSideBar;